module.exports = __webpack_public_path__ + "static/media/Acumin-BdItPro.4f0a6396.otf";